// extracted by mini-css-extract-plugin
export default {"legalContent":"Legal_legalContent__yw1X1"};